import { useUser } from '../../../global/auth/useUser';
import { useCampfireQuery } from '../../../global/network/useCampfireQuery';
import { GetAdminConsoleBulletinSettings } from '../../admin/admin-console/admin-console-content-pages/admin-console-bulletin-settings/__generated__/GetAdminConsoleBulletinSettings';
import { GET_ADMIN_CONSOLE_BULLETIN_SETTINGS } from '../../admin/admin-console/admin-console-content-pages/admin-console-bulletin-settings/admin-console-bulletin-settings.gql';

export const useCanEditBulletinsState = (): { canEdit: boolean; loading: boolean } => {
  const {
    user: { userIdentityService },
  } = useUser();

  const { data, loading } = useCampfireQuery<GetAdminConsoleBulletinSettings, undefined>(
    GET_ADMIN_CONSOLE_BULLETIN_SETTINGS
  );

  if (userIdentityService.isVmAdmin) return { canEdit: true, loading: false };

  return {
    canEdit: Boolean(userIdentityService.isProgramManager && data?.vm.bulletinAllowManagerAction),
    loading: Boolean(userIdentityService.isProgramManager && loading && !data),
  };
};

export const useCanEditBulletins = (): boolean => useCanEditBulletinsState().canEdit;
